/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M7 7l5 5l-5 5", "key": "svg-0" }], ["path", { "d": "M13 7l5 5l-5 5", "key": "svg-1" }]];
const IconChevronsRight = createReactComponent("outline", "chevrons-right", "ChevronsRight", __iconNode);

export { __iconNode, IconChevronsRight as default };
//# sourceMappingURL=IconChevronsRight.mjs.map
